module.exports = __webpack_public_path__ + "img/logo-header.6d3004cd.svg";